/**
 * Known calculation_settings keys (mirrors installment-database's
 * CalculationSettings seeder). Shown as a pickable catalog when adding a
 * new setting — the field key itself is free text, this is just a helper
 * so admins don't have to remember/retype the exact key names the
 * calculation engine actually reads.
 */
export interface CalculationSettingKeyCatalogEntry {
  key: string;
  description: string;
}

export const CALCULATION_SETTING_KEY_CATALOG: CalculationSettingKeyCatalogEntry[] = [
  { key: "min_dp_percentage_tfs_owned", description: "Min down payment % for TFS-owned units (Rates!E34:F36)" },
  { key: "min_dp_percentage_non_tfs_owned", description: "Min down payment % for non-TFS-owned units (Rates!E34:F36)" },
  { key: "dst_percentage", description: "DST / variable processing fee, % of loan (Rates!G31)" },
  { key: "processing_fee_fixed", description: "Fixed processing fee, PHP (Rates!G30)" },
  { key: "ci_fee", description: "Credit investigation fee, PHP (sheet C45)" },
  { key: "transfer_fee", description: "Transfer fee, PHP (sheet C46)" },
  { key: "loan_rounding_step", description: "Loan amount rounds up to this step, PHP (sheet C47)" },
  { key: "cashout_rounding_step", description: "Cashout floor rounds up to this step, PHP (sheet C49)" },
  { key: "monthly_rounding_step", description: "Quoted monthly amort rounds up to this step, PHP (sheet C50)" },
  { key: "quote_validity_days", description: "Quote validity, in days (sheet C51)" },
  { key: "tier_acv_percent_addon", description: "ACV tier % add-on to unit price (sheet B54:C54)" },
  { key: "tier_acv_fixed_addon", description: "ACV tier fixed add-on, PHP (sheet B54:D54)" },
  { key: "tier_regular_percent_addon", description: "Regular tier % add-on to unit price (sheet B55:C55)" },
  { key: "tier_regular_fixed_addon", description: "Regular tier fixed add-on, PHP (sheet B55:D55)" },
  { key: "insurance_own_damage_rate", description: "Insurance own damage rate, % of base price (Insurance Calc.!B5)" },
  { key: "insurance_acts_of_nature_rate", description: "Insurance acts-of-nature rate, % of base price (Insurance Calc.!B6)" },
  { key: "insurance_property_damage_fixed", description: "Insurance property damage, fixed PHP (Insurance Calc.!B7)" },
  { key: "insurance_bodily_injury_fixed", description: "Insurance bodily injury, fixed PHP (Insurance Calc.!B8)" },
  { key: "insurance_doc_stamps_rate", description: "Insurance doc stamps rate, % of subtotal (Insurance Calc.!B11)" },
  { key: "insurance_evat_rate", description: "Insurance EVAT rate, % of subtotal (Insurance Calc.!B12)" },
  { key: "insurance_lgu_tax_rate", description: "Insurance LGU tax rate, % of subtotal (Insurance Calc.!B13)" },
];
